//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';

import { MediaLibrarySourcesDropdownItemData } from '@media-library/components/top-bar/sources-dropdown/mediaLibrarySourcesDropdownConstants';
import { SourcesModal } from '@media-library/components/top-bar/sources-modals/SourcesModal';
import { CREATE_OR_UPDATE_USER_PERMISSION } from '@media-library/constants/mediaLibraryConstants';
import { MediaLibraryTrackingIds } from '@media-library/constants/mediaLibraryTrackingIds';

interface AllTeamMembersModalProps {
  handleChangeSelects: (
    updatedSources: MediaLibrarySourcesDropdownItemData,
  ) => void;
  handleCloseModal: () => void;
  isOpen: boolean;
  teamMedia: MediaLibrarySourcesDropdownItemData;
}

export const AllTeamMembersModal = ({
  handleChangeSelects,
  handleCloseModal,
  isOpen,
  teamMedia,
}: AllTeamMembersModalProps) => {
  return (
    <SourcesModal
      applyButtonTrackingId={
        MediaLibraryTrackingIds.APPLY_ALL_TEAM_MEMBERS_MODAL
      }
      cancelButtonTrackingId={
        MediaLibraryTrackingIds.CLOSE_ALL_TEAM_MEMBERS_MODAL
      }
      handleChangeSelects={handleChangeSelects}
      handleCloseModal={handleCloseModal}
      isOpen={isOpen}
      searchBarPlaceholder='Search team members'
      searchBarTrackingIdPrefix={
        MediaLibraryTrackingIds.ALL_TEAM_MEMBERS_MODAL_SEARCH_BAR
      }
      searchBarVisuallyHiddenLabel='Search team members'
      sourcesGroup={teamMedia}
      tertiaryButtonInfo={{
        content: 'Manage Team Members',
        permissionName: CREATE_OR_UPDATE_USER_PERMISSION,
        state: 'account-settings.users',
        trackingId:
          MediaLibraryTrackingIds.ALL_TEAM_MEMBERS_MODAL_MANAGE_TEAM_MEMBERS_LINK,
      }}
      title='All Team Members'
    />
  );
};
